import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ImportAnnotationsBl } from '../../../../importAnnotations.bl';
import { ImportAnnotationConflict, ResolveConflictDecision } from '../../../../models/ImportAnnotationsConflicts';
import { ResolveConflictTile } from './ResolveConflictTile';

interface IProps {
  conflict: ImportAnnotationConflict;
}

export const ResolveConflictTileContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(ImportAnnotationsBl.$);

  const handleKeepOriginal = (): void => {
    changeDecision(ResolveConflictDecision.keepOriginal);
  };

  const handleReplaceAnnotations = (): void => {
    changeDecision(ResolveConflictDecision.replaceAnnotation);
  };

  const changeDecision = (decision: ResolveConflictDecision): void => {
    bl.changeConflictDecision({ ...props.conflict, decision });
  };

  return (
    <ResolveConflictTile
      decision={props.conflict.decision}
      imageName={props.conflict.imageName}
      onKeepOriginal={handleKeepOriginal}
      onReplaceAnnotation={handleReplaceAnnotations}
    />
  );
});
